(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["StaffCard"] = factory();
	else
		root["StaffCard"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _staffCard = __webpack_require__(1);
	
	var _staffCard2 = _interopRequireDefault(_staffCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _staffCard2.default;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _staffCardBase = __webpack_require__(2);
	
	var _staffCardBase2 = _interopRequireDefault(_staffCardBase);
	
	var _frames = __webpack_require__(14);
	
	__webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// http://ejohn.org/blog/comparing-document-position/
	var contains = function contains(a, b) {
	    return typeof a.contains === 'function' ? a !== b && a.contains(b) : (a.compareDocumentPosition(b) & 16) > 0;
	};
	
	var isConnected = function isConnected(node) {
	    return contains(document.body, node);
	};
	
	if (typeof window.Node === 'function' && 'isConnected' in window.Node.prototype) {
	    isConnected = function isConnected(node) {
	        return node.isConnected;
	    };
	}
	
	var StaffCard = function (_StaffCardBase) {
	    _inherits(StaffCard, _StaffCardBase);
	
	    function StaffCard() {
	        var _ref;
	
	        _classCallCheck(this, StaffCard);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, (_ref = StaffCard.__proto__ || Object.getPrototypeOf(StaffCard)).call.apply(_ref, [this].concat(args)));
	
	        _this._checkAnchorFrame = null;
	        return _this;
	    }
	    /**
	     * Включить слежение за якорным элементом
	     * @private
	     * */
	
	
	    _createClass(StaffCard, [{
	        key: '_startCheckAnchor',
	        value: function _startCheckAnchor() {
	            var _this2 = this;
	
	            var onTick = function onTick() {
	                if (isConnected(_this2.element)) {
	                    _this2._checkAnchorFrame = (0, _frames.setFrame)(onTick);
	                } else {
	                    _this2.destruct();
	                }
	            };
	
	            this._stopCheckAnchor();
	
	            onTick();
	        }
	        /**
	         * Прекратить слежение за якорным элементом
	         * @private
	         * */
	
	    }, {
	        key: '_stopCheckAnchor',
	        value: function _stopCheckAnchor() {
	            (0, _frames.delFrame)(this._checkAnchorFrame);
	            this._checkAnchorFrame = null;
	        }
	        /**
	         * @inheritdoc
	         * */
	
	    }, {
	        key: '_delPopup',
	        value: function _delPopup() {
	            this._stopCheckAnchor();
	
	            return _get(StaffCard.prototype.__proto__ || Object.getPrototypeOf(StaffCard.prototype), '_delPopup', this).call(this);
	        }
	        /**
	         * @inheritdoc
	         * */
	
	    }, {
	        key: '_createPopup',
	        value: function _createPopup() {
	            var result = _get(StaffCard.prototype.__proto__ || Object.getPrototypeOf(StaffCard.prototype), '_createPopup', this).call(this);
	
	            this._startCheckAnchor();
	
	            return result;
	        }
	    }]);
	
	    return StaffCard;
	}(_staffCardBase2.default);
	
	exports.default = StaffCard;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(3);
	var UserInfo = __webpack_require__(11);
	var request = __webpack_require__(12);
	
	var VERSION = __webpack_require__(13).version;
	var HIDE_DELAY = 200;
	var SHOW_DELAY = 500;
	
	var OFFSET = 10;
	
	var popupTpl = '<div class="' + css.row + ' ' + css.head + '">&nbsp;</div>\n<div class="' + css.row + '">\n    <div class="' + css.avatar + '"></div>\n    <div class="' + css.body + '">\n        <div class="' + css.spin + '"></div>\n    </div>\n</div>\n<div class="' + css.row + ' ' + css.location + '"></div>';
	
	var StaffCardBase = function () {
	    _createClass(StaffCardBase, null, [{
	        key: 'version',
	        get: function get() {
	            return VERSION;
	        }
	    }]);
	
	    function StaffCardBase(element, login) {
	        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	        _classCallCheck(this, StaffCardBase);
	
	        if (typeof element === 'string') {
	            element = document.querySelector(element);
	        } else if (window.jQuery && element instanceof window.jQuery) {
	            // eslint-disable-next-line no-console
	            console.warn('StaffCard работает без jQuery, передайте в конструктор HTMLElement или селектор');
	            element = element[0];
	        }
	
	        this.element = element;
	        this.login = login;
	        this.options = Object.assign({
	            userInfo: {
	                target: '_self'
	            }
	        }, options);
	
	        this.popup = null;
	
	        this._hideTimeout = null;
	        this._showTimeout = null;
	
	        this.onHover = this.onHover.bind(this);
	        this._onLeave = this._onLeave.bind(this);
	        this._onWindowMouseMove = this._onWindowMouseMove.bind(this);
	
	        this._mouseCaptureElement();
	    }
	
	    _createClass(StaffCardBase, [{
	        key: 'onHover',
	
	        /**
	         * Обработка наведения крусора на element
	         */
	        value: function onHover() {
	            this._startShow();
	        }
	        /**
	         * Обработка убирания курсора с элемента
	         * @private
	         */
	
	    }, {
	        key: '_onLeave',
	        value: function _onLeave() {
	            this._startHide();
	        }
	        /**
	         * Удаляет popup из DOM, предварительно остановив все таймеры
	         */
	
	    }, {
	        key: 'destruct',
	        value: function destruct() {
	            this._cancelShow();
	            this._cancelHide();
	            this._delPopup();
	        }
	        /**
	         * Возвращает z-index для попапа
	         * Берётся наибольшый z-index родителей + 1, но не меньше 100
	         * @private
	         * @returns {Number}
	         */
	
	    }, {
	        key: '_zIndex',
	        value: function _zIndex() {
	            var parent = this.element.parentNode;
	            var zIndex = 100;
	
	            while (parent && parent !== document.body) {
	                var ParentZIndex = window.getComputedStyle(parent).getPropertyValue('z-index');
	
	                if (!isNaN(ParentZIndex)) {
	                    zIndex = Math.max(zIndex, ParentZIndex);
	                }
	
	                parent = parent.parentNode;
	            }
	
	            return zIndex + 1;
	        }
	        /**
	         * Отмена скрытия попапа
	         * @private
	         */
	
	    }, {
	        key: '_cancelHide',
	        value: function _cancelHide() {
	            clearTimeout(this._hideTimeout);
	            this._hideTimeout = null;
	        }
	        /**
	         * Скрытие попапа
	         * @private
	         */
	
	    }, {
	        key: '_startHide',
	        value: function _startHide() {
	            var _this = this;
	
	            this._cancelHide();
	            this._cancelShow();
	            this._hideTimeout = setTimeout(function () {
	                if (!_this.popup) {
	                    return;
	                }
	
	                _this.popup.classList.remove(css.popup_visible);
	                var listener = function listener() {
	                    _this.popup.removeEventListener('transitionend', listener);
	                    _this._delPopup();
	                };
	                _this.popup.addEventListener('transitionend', listener);
	            }, HIDE_DELAY);
	        }
	        /**
	         * Отмена открытия попапа
	         * @private
	         * */
	
	    }, {
	        key: '_cancelShow',
	        value: function _cancelShow() {
	            clearTimeout(this._showTimeout);
	            this._showTimeout = null;
	        }
	        /**
	         * Открытие попапа
	         * @private
	         * */
	
	    }, {
	        key: '_startShow',
	        value: function _startShow() {
	            var _this2 = this;
	
	            this._cancelHide();
	            this._cancelShow();
	            this._showTimeout = setTimeout(function () {
	                _this2.popup = _this2._createPopup();
	
	                _this2._position(true);
	                _this2.popup.classList.add(css.popup_visible);
	                _this2._requestData().then(function (data) {
	                    _this2._renderUser(data);
	                    _this2._position(false);
	                }).catch(function () {
	                    return _this2._renderError();
	                });
	            }, SHOW_DELAY);
	        }
	        /**
	         * Обработка движения курсора над window
	         * @param {Event} e
	         * @private
	         */
	
	    }, {
	        key: '_onWindowMouseMove',
	        value: function _onWindowMouseMove(e) {
	            function check(elem) {
	                return elem === e.target || elem !== e.target && elem.contains(e.target);
	            }
	
	            if (check(this.popup) || check(this.element)) {
	                this._cancelHide();
	            } else {
	                this._startHide();
	            }
	        }
	        /**
	         * Позиционирование попапа
	         * @param {Boolean} forceLayout — принудительная перерисовка
	         * @private
	         */
	
	    }, {
	        key: '_position',
	        value: function _position(forceLayout) {
	            if (forceLayout) {
	                this.popup.style.transition = 'none';
	            }
	
	            this.popup.style.top = 0;
	            this.popup.style.left = 0;
	            var popupWidth = this.popup.offsetWidth;
	            var popupHeight = this.popup.offsetHeight;
	            var documentWidth = document.documentElement.clientWidth;
	            var windowHeight = window.innerHeight;
	            var sideClass = void 0;
	
	            var _element$getBoundingC = this.element.getBoundingClientRect(),
	                top = _element$getBoundingC.top,
	                left = _element$getBoundingC.left,
	                right = _element$getBoundingC.right,
	                bottom = _element$getBoundingC.bottom,
	                width = _element$getBoundingC.width;
	
	            var elementHeight = top - bottom;
	
	            left += window.pageXOffset;
	            right += window.pageXOffset;
	
	            var isFitsRight = documentWidth - right - OFFSET >= popupWidth;
	            var isFitsLeft = left - OFFSET >= popupWidth;
	
	            if (isFitsRight) {
	                sideClass = css.popup_side_right;
	                left += width;
	            } else if (isFitsLeft) {
	                sideClass = css.popup_side_left;
	                left -= popupWidth;
	            } else {
	                sideClass = css.popup_side_right;
	                // двойной отступ, так как сам popup тоже с OFFSET
	                left += Math.max(OFFSET, documentWidth - left - OFFSET - popupWidth);
	            }
	
	            // отображать под элементом
	            if (!isFitsRight && !isFitsLeft) top += elementHeight;
	
	            //vertical alignment
	            if (windowHeight - (top + popupHeight) < 0 && windowHeight > popupHeight) {
	                if (bottom > windowHeight) {
	                    top = windowHeight - popupHeight;
	                } else {
	                    top = bottom - popupHeight;
	                }
	            }
	            top += window.pageYOffset;
	
	            this.popup.classList.remove(css.popup_side_left, css.popup_side_right);
	            this.popup.classList.add(sideClass);
	            this.popup.style.top = top + 'px';
	            this.popup.style.left = left + 'px';
	            this.popup.style.zIndex = this._zIndex();
	            if (forceLayout) {
	                //force update layout to get correct animation
	                window.getComputedStyle(this.popup).getPropertyValue('transform');
	                this.popup.style.transition = '';
	            }
	        }
	        /**
	         * Создание попапа
	         * @returns {HTMLElement}
	         * @protected
	         */
	
	    }, {
	        key: '_createPopup',
	        value: function _createPopup() {
	            var popup = document.createElement('div');
	            popup.innerHTML = popupTpl;
	            popup.classList.add(css.popup);
	            document.body.appendChild(popup);
	
	            this._mouseCaptureWindow();
	
	            return popup;
	        }
	        /**
	         * Удаляет popup из DOM
	         * @protected
	         * */
	
	    }, {
	        key: '_delPopup',
	        value: function _delPopup() {
	            this._mouseCaptureElement();
	
	            if (!this.popup) {
	                return;
	            }
	
	            this.popup.parentNode.removeChild(this.popup);
	            this.popup = null;
	        }
	        /**
	         * Включить проверку положения курсора над попапом
	         * @private
	         */
	
	    }, {
	        key: '_mouseCaptureWindow',
	        value: function _mouseCaptureWindow() {
	            this.element.removeEventListener('mouseenter', this.onHover);
	            this.element.removeEventListener('mouseleave', this._onLeave);
	            window.addEventListener('mousemove', this._onWindowMouseMove);
	        }
	        /**
	         * Включить проверку положения курсора над элементом
	         * @private
	         */
	
	    }, {
	        key: '_mouseCaptureElement',
	        value: function _mouseCaptureElement() {
	            this.element.addEventListener('mouseenter', this.onHover);
	            this.element.addEventListener('mouseleave', this._onLeave);
	            window.removeEventListener('mousemove', this._onWindowMouseMove);
	        }
	        /**
	         * Получение данных пользователя
	         * @returns {Promise}
	         * @private
	         */
	
	    }, {
	        key: '_requestData',
	        value: function _requestData() {
	            if (!this.userData) {
	                this.userData = request.getJSON('//center.yandex-team.ru/api/staff_cards/?' + this.login + '&format=json');
	            }
	            return this.userData;
	        }
	        /**
	         * Отрисовка контента попапа
	         * @param data
	         * @private
	         */
	
	    }, {
	        key: '_renderUser',
	        value: function _renderUser(data) {
	            var user = data[this.login];
	            if (!user) {
	                return this._renderError();
	            }
	            new UserInfo(this.popup, user, this.options.userInfo);
	        }
	        /**
	         * Отрисовка ошибки
	         * @private
	         */
	
	    }, {
	        key: '_renderError',
	        value: function _renderError() {
	            this.userData = null;
	            if (!this.popup) {
	                return;
	            }
	            this.popup.querySelector('.' + css.avatar).classList.add(css.avatar_error);
	            this.popup.querySelector('.' + css.body).innerHTML = '<b>Ooops!</b>';
	        }
	    }, {
	        key: 'login',
	        get: function get() {
	            return this._login;
	        },
	        set: function set(value) {
	            this._login = value;
	            this.userData = null;
	        }
	    }]);
	
	    return StaffCardBase;
	}();
	
	exports.default = StaffCardBase;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(4);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js?modules&localIdentName=staff-card__[local]!./styles.css", function() {
				var newContent = require("!!../node_modules/css-loader/index.js?modules&localIdentName=staff-card__[local]!./styles.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports
	
	
	// module
	exports.push([module.id, ".staff-card__popup{position:absolute;box-sizing:border-box;min-width:300px;max-width:450px;min-height:150px;transition-timing-function:ease-out;transition-duration:.15s;transition-property:transform,opacity;opacity:0;border:1px solid rgba(0,0,0,.1);background:#fff;box-shadow:0 10px 20px -5px rgba(0,0,0,.4);font:13px Arial,Helvetica,sans-serif}.staff-card__popup_side_left{margin-left:-10px;transform:translateX(-5%)}.staff-card__popup_side_right{margin-left:10px;transform:translateX(5%)}.staff-card__popup_visible{transform:translateX(0);opacity:1}.staff-card__row{padding:10px 15px 0}.staff-card__avatar{position:relative;float:left;width:100px;height:100px;background:url(" + __webpack_require__(6) + ") 50% no-repeat}.staff-card__avatar:after{position:absolute;top:0;right:0;bottom:0;left:0;content:\" \";border:1px solid rgba(0,0,0,.12)}.staff-card__avatar_error{transform-origin:0 0;animation:staff-card__error .5s linear forwards}.staff-card__head{font-weight:700}.staff-card__location{margin-bottom:10px}.staff-card__location_loaded:before{display:inline-block;width:15px;height:16px;margin-right:.3em;content:\" \";vertical-align:bottom;background:url(" + __webpack_require__(7) + ") 50% no-repeat}.staff-card__body{position:relative;min-height:100px;margin-left:115px}.staff-card__spin{position:absolute;top:50%;left:50%;width:24px;height:24px;margin-top:-12px;margin-left:-12px;animation:staff-card__spin 1s infinite linear;background:url(" + __webpack_require__(8) + ") 50% no-repeat;background-size:contain}.staff-card__visit{color:#999}.staff-card__link{transition:color .15s ease-out;text-decoration:none;color:#07c}.staff-card__link_type_user{display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;color:#000;font-size:18px}.staff-card__link:hover,.staff-card__link_type_user:first-letter{color:red}.staff-card__button{margin:2px;padding:0 13px;cursor:pointer;white-space:nowrap;border:1px solid rgba(0,0,0,.2);border-radius:3px;outline:none;background:transparent;font:13px Arial,sans-serif;line-height:26px}.staff-card__button:active,.staff-card__button:hover{border-color:rgba(0,0,0,.3)}.staff-card__button:active{background-color:#f6f5f3}.staff-card__button_jabber:before{display:inline-block;width:8px;height:8px;margin-right:6px;content:\"\";border-radius:100%;background:#aaa}.staff-card__button_status_offline:before{background:#aaa}.staff-card__button_status_available:before,.staff-card__button_status_chat:before{background:#3a3}.staff-card__button_status_away:before{background:#4af}.staff-card__button_status_xa:before{background:#abb}.staff-card__button_status_dnd:before{background:#e54}.staff-card__button_status_notinlist:before{background:#cd8}.staff-card__button_status_none:before{content:none}.staff-card__button_phone:before{position:relative;top:1px;display:inline-block;width:11px;height:11px;margin-right:5px;content:\" \";background:url(" + __webpack_require__(9) + ") 50% no-repeat}.staff-card__button_calling,.staff-card__button_phone:hover:before{animation:staff-card__call .1s infinite alternate linear}.staff-card__input{z-index:1;flex:1;padding:0 7px;border:1px solid rgba(0,0,0,.2);font:13px Arial,sans-serif;line-height:26px}.staff-card__input:focus{border-color:#ffdb4d;outline:none;box-shadow:inset 0 0 0 1px #ffdb4d}.staff-card__contacts{display:flex;align-items:flex-start;min-width:195px;margin-top:5px}.staff-card__contact{width:100px;margin:2px}.staff-card__contact__row{display:flex}.staff-card__contact__link{display:block;padding:5px 0 5px 20px;white-space:nowrap}.staff-card__contact__reset{width:16px;margin-right:4px;cursor:pointer;color:#888;font-size:20px;font-weight:300}.staff-card__gap{position:relative;z-index:0;margin:4px;padding:8px 15px;text-align:center}.staff-card__gap__overlay{position:absolute;z-index:-1;top:0;right:0;bottom:0;left:0;opacity:.5}.staff-card__gap__link{color:#000}@keyframes staff-card__error{0%{transform:rotate(0deg)}5%{transform:rotate(1deg)}10%{transform:rotate(0deg)}50%{transform:rotate(20deg)}60%{transform:rotate(10deg)}90%{transform:rotate(16deg)}to{transform:rotate(15deg)}}@keyframes staff-card__spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes staff-card__call{0%{transform:rotate(0deg) translateZ(0)}to{transform:rotate(15deg) translateZ(0)}}", ""]);
	
	// exports
	exports.locals = {
		"popup": "staff-card__popup",
		"popup_side_left": "staff-card__popup_side_left",
		"popup_side_right": "staff-card__popup_side_right",
		"popup_visible": "staff-card__popup_visible",
		"row": "staff-card__row",
		"avatar": "staff-card__avatar",
		"avatar_error": "staff-card__avatar_error",
		"error": "staff-card__error",
		"head": "staff-card__head",
		"location": "staff-card__location",
		"location_loaded": "staff-card__location_loaded",
		"body": "staff-card__body",
		"spin": "staff-card__spin",
		"visit": "staff-card__visit",
		"link": "staff-card__link",
		"link_type_user": "staff-card__link_type_user",
		"button": "staff-card__button",
		"button_jabber": "staff-card__button_jabber",
		"button_status_offline": "staff-card__button_status_offline",
		"button_status_available": "staff-card__button_status_available",
		"button_status_chat": "staff-card__button_status_chat",
		"button_status_away": "staff-card__button_status_away",
		"button_status_xa": "staff-card__button_status_xa",
		"button_status_dnd": "staff-card__button_status_dnd",
		"button_status_notinlist": "staff-card__button_status_notinlist",
		"button_status_none": "staff-card__button_status_none",
		"button_phone": "staff-card__button_phone",
		"call": "staff-card__call",
		"button_calling": "staff-card__button_calling",
		"input": "staff-card__input",
		"contacts": "staff-card__contacts",
		"contact": "staff-card__contact",
		"contact__row": "staff-card__contact__row",
		"contact__link": "staff-card__contact__link",
		"contact__reset": "staff-card__contact__reset",
		"gap": "staff-card__gap",
		"gap__overlay": "staff-card__gap__overlay",
		"gap__link": "staff-card__gap__link"
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAMAAACOacfrAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABVQTFRFAAAAzMzMo6Oj5eXlgoKCaGho/f39iySGTQAAAAd0Uk5T////////ABpLA0YAAAAqSURBVHjaYmBAADY2BmSAymPALQfUxwYCEJKaPEYmBlYWJkZmNjaAAAMAckQCBYTNkoEAAAAASUVORK5CYII="

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAMAAACecocUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFAAAA/f39emVIHQAAAAJ0Uk5T/wDltzBKAAAAMElEQVR42lTLAQoAAARD0b/7X5oYQenRoCogxzAXDnGgu7MFc6I6fncv/reXCgEGABPTAFKFjG5BAAAAAElFTkSuQmCC"

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var css = __webpack_require__(3);
	var request = __webpack_require__(12);
	
	var gapTpl = function gapTpl(gap) {
	    return '<div style="background: ' + gap.color + '" class="' + css.gap__overlay + '"></div>\n<a class="' + css.link + ' ' + css.gap__link + '" href="' + gap.url + '">' + gap.name + ' ' + gap.time + '</a>';
	};
	
	var locationTpl = function locationTpl(user) {
	    var place = user.table ? '<a class="' + css.link + '" href="' + user.table.url + '">' + user.office + '</a>' : '<span>' + user.office + '</span>';
	
	    var visit = user.last_office ? '<span class="' + css.visit + '"> \u2014 ' + user.last_office.office + ', ' + user.last_office.ago + '</span>' : '';
	
	    return place + ' ' + visit;
	};
	
	var emailButtonTpl = function emailButtonTpl(user) {
	    return '<button class="' + css.button + ' ' + css.button_jabber + ' ' + css['button_status_' + (user.is_dismissed ? 'none' : user.jabber_status)] + '">' + user.work_email.replace(/yandex-team\.ru$/, '') + '</button>';
	};
	
	var contactsTpl = function contactsTpl(user, width) {
	    return '<div class="' + css.contact + '" style="width: ' + width + 'px">\n    <div class="' + css.contact__row + '">\n        <span class="' + css.contact__reset + ' ' + css.link + '">\u21BA</span>\n        <input class="' + css.input + '" type="text" value="' + user.work_email + '" />\n    </div>\n    <a class="' + css.link + ' ' + css.contact__link + '" href="mailto:' + user.work_email + '">Write email</a>\n    <a class="' + css.link + ' ' + css.contact__link + '" href="xmpp:' + user.work_email + '">Write to jabber</a>\n</div>';
	};
	
	var userBodyTpl = function userBodyTpl(user, options) {
	    return '\n    <div><a class="' + css.link + ' ' + css.link_type_user + '" href="//staff.yandex-team.ru/' + user.login + '" target="' + options.target + '">' + user.first_name + ' ' + user.last_name + '</a></div>\n    <div>' + user.position + '</div>\n    <div class="' + css.contacts + '">\n        ' + emailButtonTpl(user) + '\n        ' + (user.phones && user.phones.work ? '<button class="' + css.button + ' ' + css.button_phone + '">' + user.phones.work + '</button>' : '') + '\n    </div>\n    <div class="' + css.contacts + '">\n        ' + (user.phones && user.phones.mobile ? '<button class="' + css.button + ' ' + css.button_phone + '">' + user.phones.mobile + '</button>' : '') + '\n    </div>\n';
	};
	
	module.exports = function () {
	    function UserInfo(container, user) {
	        var _this = this;
	
	        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	        _classCallCheck(this, UserInfo);
	
	        container.querySelector('.' + css.head).textContent = user.dep.name;
	        container.querySelector('.' + css.avatar).innerHTML = '<img src="' + user.avatar + '">';
	        container.querySelector('.' + css.body).innerHTML = userBodyTpl(user, options);
	
	        if (user.is_dismissed) {
	            var location = container.querySelector('.' + css.location);
	            location.parentNode.removeChild(location);
	        } else {
	            var _location = container.querySelector('.' + css.location);
	            _location.classList.add(css.location_loaded);
	            _location.innerHTML = locationTpl(user);
	        }
	
	        if (user.gap) {
	            var gapElement = document.createElement('div');
	            gapElement.innerHTML = gapTpl(user.gap);
	            gapElement.classList.add(css.gap);
	            container.appendChild(gapElement);
	        }
	
	        addChildEventListener(container, 'click', '.' + css.button_jabber, function () {
	            var button = container.querySelector('.' + css.button_jabber);
	            button.outerHTML = contactsTpl(user, button.offsetWidth);
	            container.querySelector('.' + css.input).select();
	        });
	        addChildEventListener(container, 'click', '.' + css.contact__reset, function () {
	            container.querySelector('.' + css.contact).outerHTML = emailButtonTpl(user);
	        });
	        addChildEventListener(container, 'click', '.' + css.button_phone, function (button) {
	            return _this.callPhone(button);
	        });
	    }
	
	    _createClass(UserInfo, [{
	        key: 'callPhone',
	        value: function callPhone(button) {
	            function onFinish() {
	                pendingTasks--;
	                if (pendingTasks === 0) {
	                    button.classList.remove(css.button_calling);
	                }
	            }
	
	            var number = button.textContent;
	            var pendingTasks = 2;
	            button.classList.add(css.button_calling);
	            setTimeout(onFinish, 1000);
	
	            request.getJSON('//staff.yandex-team.ru/api/call/' + number + '?format=json').then(onFinish).catch(onFinish);
	        }
	    }]);
	
	    return UserInfo;
	}();
	
	function addChildEventListener(parent, eventType, childSelector, handler) {
	    parent.addEventListener(eventType, function (event) {
	        var child = event.target.closest(childSelector);
	
	        if (child) {
	            handler(child);
	        }
	    });
	}

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	function getJSON(url) {
	    return new Promise(function (resolve, reject) {
	        var xhr = new XMLHttpRequest();
	
	        Object.assign(xhr, {
	            withCredentials: true,
	            onload: function onload() {
	                try {
	                    resolve(JSON.parse(xhr.response));
	                } catch (e) {
	                    reject();
	                }
	            },
	            onerror: function onerror() {
	                return reject();
	            }
	        });
	
	        xhr.open('GET', url);
	        xhr.send(null);
	    });
	}
	
	module.exports = {
	    getJSON: getJSON
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = {"name":"staff-card","version":"2.1.0","description":"","main":"dist/staff-card.js","repository":"git@github.yandex-team.ru:tools/staff-card.git","scripts":{"dev":"webpack --watch","prebuild":"rimraf dist/*","build":"npm run build:main && npm run build:min","build:main":"webpack","build:min":"webpack --optimize-minimize","start":"npm run build:main -- --watch","test":"mocha --compilers js:babel-register,css:css-modules-require-hook/preset --require ./util/setup-jsdom","coverage":"nyc --reporter=lcov --reporter=text npm test","preversion":"releaser changelog -v v${npm_package_version}","version":"git add changelog.md","postversion":"git push && git push --tags && npm run deploy","predeploy":"npm run build","deploy":"npm run mds:sync_version && npm run mds:sync_latest","mds:sync_version":"aws s3 --endpoint-url=https://s3.mds.yandex.net sync ./dist/ s3://${npm_package_name}/v${npm_package_version}/","mds:sync_latest":"aws s3 --endpoint-url=https://s3.mds.yandex.net sync ./dist/ s3://${npm_package_name}/_/"},"keywords":[],"author":"","license":"ISC","files":["dist","src"],"nyc":{"include":["src/*.js"]},"devDependencies":{"babel-core":"^6.7.4","babel-loader":"^6.2.4","babel-preset-es2015":"^6.6.0","babel-register":"^6.7.2","copy-webpack-plugin":"3.0.1","cross-env":"^1.0.7","css-loader":"^0.23.1","css-modules-require-hook":"^4.0.0","eslint":"^2.7.0","expect":"^1.16.0","file-loader":"0.9.0","html-webpack-plugin":"^2.15.0","jsdom":"^8.3.1","json-loader":"^0.5.4","mocha":"^2.4.5","nyc":"^6.4.0","postcss":"^6.0.19","promise.prototype.finally":"^1.0.1","rimraf":"^2.5.2","style-loader":"^0.13.1","url-loader":"^0.5.7","webpack":"~1.13.3","webpack-dev-server":"1.15.*"},"dependencies":{"element-closest":"^3.0.1"}}

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var setFrame = window.requestAnimationFrame;
	var delFrame = window.cancelAnimationFrame;
	
	if (typeof setFrame !== 'function') {
	    exports.setFrame = setFrame = function setFrame(fn) {
	        return window.setTimeout(fn, 1000 / 60);
	    };
	    exports.delFrame = delFrame = window.clearTimeout;
	}
	
	exports.setFrame = setFrame;
	exports.delFrame = delFrame;

/***/ },
/* 15 */
/***/ function(module, exports) {

	!function(e){var t=e.Element.prototype;"function"!=typeof t.matches&&(t.matches=t.msMatchesSelector||t.mozMatchesSelector||t.webkitMatchesSelector||function(e){for(var t=(this.document||this.ownerDocument).querySelectorAll(e),o=0;t[o]&&t[o]!==this;)++o;return Boolean(t[o])}),"function"!=typeof t.closest&&(t.closest=function(e){for(var t=this;t&&1===t.nodeType;){if(t.matches(e))return t;t=t.parentNode}return null})}(window);


/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// staff-card.min.js